import {
  RelatorioReceitasPdfResponse,
  RelatorioReceitasFields,
} from "core/features/relatorios/typings";
import { PDFLayout } from "ui/components/PDF";
import { formatMoney } from "infra/helpers/number";
import ItemTable from "./components/ItemTable/index";
import { View } from "@react-pdf/renderer";
import colors from "theme/colors";
import TotalRow from "./components/TotalRow/index";
import ResumoPorCategoria from "ui/components/Relatorio/ResumoPorCategoria";

interface PDFRelatorioReceitasProps {
  data?: RelatorioReceitasPdfResponse;
  includeDocumentWrapper?: boolean;
  renderUnidade?: boolean;
  renderProprietario?: boolean;
  renderResumoCategorias?: boolean;
  fields?: RelatorioReceitasFields[];
}

function PDFRelatorioReceitas({
  data,
  includeDocumentWrapper = true,
  renderProprietario = true,
  renderResumoCategorias = true,
  renderUnidade = true,
  fields,
}: PDFRelatorioReceitasProps) {
  const getTitle = () => {
    if (!data?.totalUnidades) {
      return `Total(${data?.totalCobrancas}${
        data?.totalCobrancas === 1 ? " cobrança" : " cobranças"
      } de ${data?.totalPessoas ?? 0}${
        data?.totalPessoas === 1 ? " pessoa" : " pessoas"
      })`;
    }

    return `Total(${data?.totalCobrancas}${
      data?.totalCobrancas === 1 ? " cobrança" : " cobranças"
    } de ${data?.totalUnidades ?? 0}${
      data?.totalUnidades === 1 ? " unidade" : " unidades"
    })`;
  };

  return (
    <PDFLayout
      includeDocument={includeDocumentWrapper}
      fontSize={7}
      assinaturas={data?.assinaturas}
      headerProps={{
        logo: data?.logo!,
        tenant: data?.nomeTenant!,
        title: `Relatório de Receitas`,
        cards: [
          {
            title: "Cobranças",
            value: data?.totalCobrancas?.toString() || "",
          },
          {
            title: data?.totalUnidades ? "Unidades" : "Pessoas",
            value:
              (data?.totalUnidades
                ? data?.totalUnidades?.toString()
                : data?.totalPessoas?.toString()) || "0",
            alignItems: "flex-end",
          },
          {
            title: "Total",
            value: formatMoney(data?.valorTotal),
            alignItems: "flex-end",
          },
        ],
      }}
      footerProps={{
        tenant: data?.nomeTenant!,
        logo: data?.logoAdm!,
        endereco1: data?.endereco1!,
        endereco2: data?.endereco2!,
      }}
    >
      {data?.items.map((item, index) => (
        <View
          key={item.unidadeId}
          style={{ marginBottom: index < data?.items.length - 1 ? 8 : 6 }}
        >
          <ItemTable
            item={item}
            renderUnidade={renderUnidade}
            renderProprietario={renderProprietario}
            fields={fields}
          />
        </View>
      ))}

      {data ? (
        <View
          style={{
            borderTopColor: colors.primary,
            borderTopWidth: 2,
            paddingTop: 2,
            fontWeight: "medium",
          }}
        >
          <TotalRow title={getTitle()} valorTotal={data.valorTotal} />
        </View>
      ) : null}

      {data && renderResumoCategorias ? (
        <View
          style={{
            marginTop: 32,
          }}
        >
          <ResumoPorCategoria
            data={data}
            title={`Resumo por categoria (${data?.totalCobrancas} ${
              data?.totalCobrancas === 1 ? " cobrança" : " cobranças"
            })`}
          />
        </View>
      ) : null}
    </PDFLayout>
  );
}

export default PDFRelatorioReceitas;
